import { render, staticRenderFns } from "./ActivitiesList_old.vue?vue&type=template&id=2124bd14&scoped=true&"
import script from "./ActivitiesList_old.vue?vue&type=script&lang=js&"
export * from "./ActivitiesList_old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2124bd14",
  null
  
)

export default component.exports